import React from 'react'
import { css, Global } from '@emotion/react'
import reset from "emotion-reset";

const globalCss = css`
  ${reset}
  body {
    background-color: #ffffff;
  }
`

const GlobalCSS = () => {
  return <Global styles={globalCss} />
}

export default GlobalCSS
